import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API;

axios.defaults.withCredentials = true; // penting: agar cookie dikirim otomatis

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Panggil endpoint backend untuk verifikasi cookie
        const res = await axios.get(`${REACT_APP_EXPRESS_API}/api/users/current`, {
          withCredentials: true,
        });

        if (res.status === 200 && res.data) {
          setIsAuthenticated(true);
        } else {
          throw new Error("Unauthorized");
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setIsAuthenticated(false);

        Swal.fire({
          title: "Silakan Login Dulu",
          text: "Untuk mengakses halaman ini, kamu perlu login terlebih dahulu.",
          icon: "warning",
          confirmButtonText: "Login Sekarang",
          confirmButtonColor: "#3C5896",
          allowOutsideClick: false,
          backdrop: true,
        }).then(() => navigate("/"));
      }
    };

    checkAuth();
  }, [navigate]);

  // Saat masih memeriksa login
  if (isAuthenticated === null) {
    return <p>Mengecek autentikasi...</p>;
  }

  // Jika tidak login
  if (!isAuthenticated) {
    return null;
  }

  // Jika login, tampilkan halaman child
  return <>{children}</>;
};

export default ProtectedRoute;
